
const insertComboDiv = (allowedUrls = []) => {
  const current = window.location.href;
  const isAllowed = allowedUrls.some(sub => current.includes(sub));
  if (!isAllowed) return;

  const btn = document.querySelector('.add_to_cart_holder');
  if (!btn) return;

  const promoDiv = document.createElement('div');
  promoDiv.textContent = '“¡No lo olvides! Este artículo también está en combo. Lo encontrarás justo debajo del botón ‘Agregar al carrito’ con una promo especial por comprar las tres piezas juntas. ¡Ahorra real y luce completo!”';
  promoDiv.style = `
    margin-top: -5px;
    padding: 10px;
    color: red;
    background: white;
    border: 1px solid black;
    border-radius: 4px;
    margin-bottom: 8px;
  `;

  if (typeof btn.after === 'function') {
    btn.after(promoDiv);
  } else if (btn.parentNode) {
    btn.parentNode.insertBefore(promoDiv, btn.nextSibling);
  }
};

document.addEventListener('DOMContentLoaded', () => {
  insertComboDiv([
    "kcb2316cs",
    "kcb2315jg",
    "kcb2314th"
  ]);
});

const hideParentByDisabledInputs1 = (fieldsetSelector) => {
  if (!document.querySelector('.thb-product-detail')) return; // Si no está en el template, no hace nada
  
  document.querySelectorAll(`${fieldsetSelector} input.is-disabled`).forEach(input => {
    const value = input.value.trim();
    if (value) {
      document.querySelectorAll(`[title="${value}"]`).forEach(el => {
        if (el.parentElement) {
          el.parentElement.style.setProperty('display', 'none', 'important');
        }
      });
    }
  });
};
hideParentByDisabledInputs1('.product-form__input');

document.addEventListener('DOMContentLoaded', () => { 
  hideParentByDisabledInputs1('.product-form__input');
  console.log("Me cargue");
  
});

window.addEventListener('load', () => {
  hideParentByDisabledInputs1('.product-form__input');
  console.log("Me cargue2");
});